// extracted by mini-css-extract-plugin
export default {"axis":"graph__axis___2VoIQ","hidden":"graph__hidden___qxHAq"};